import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm4.907 6.593a.875.875 0 0 0-1.237 0l-5.17 5.17-2.182-2.183a.876.876 0 0 0-1.238 1.238l2.802 2.801a.875.875 0 0 0 1.237 0l5.788-5.788a.876.876 0 0 0 0-1.238Z"
      clip-rule="evenodd"
    />
  </svg>
`;
